interface Props {
  first: string;
  last: string;
  size?: number;
}

export function UserAvatar({ first, last, size = 32 }: Props) {
  const initials = ((first[0] || "") + (last[0] || "")).toUpperCase();
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 999,
        background: "var(--accent)",
        color: "var(--accent-ink)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "var(--ui)",
        fontWeight: 600,
        fontSize: size * 0.4,
        letterSpacing: 0.5,
        flexShrink: 0,
      }}
    >
      {initials}
    </div>
  );
}
